/* eslint-disable no-console */
/* eslint-disable no-useless-concat */
/* eslint-disable no-underscore-dangle */
import { Wrap } from './styles';

import Layer from 'services/models/Layer';
import { getTurfedFeatures } from 'services/utils/layerUtils';

import ButtonTooltip from '../../ButtonTooltip';

import {CustomModalSaveAsLayer} from 'views/MapView/components/CustomModalSaveAsLayer';

import Icon from '@map/components/Icons';
/**
 * Turf é uma coleção de módulos com algoritmos geográficos.
 */
import * as turf from '@turf/turf';
/**
 * useFormik é um hook personalizado do React que retornará
 * todos os estados e auxiliares do Formik diretamente.
 */
import { useFormik } from 'formik';
/**
 * Importação da biblioteca leaflet a qual utiliza o OpenStreetMap,
 * é uma biblioteca de mapeamento leve e de codigo aberto, utiliza um banco
 * de dados geografico editável gratuito.
 */
import L from 'leaflet';
/**
 * useState é um hook que nos permite rastrear o estado em um
 * componente de função, o estado geralmente se refere a dados ou
 * propriedads que precisam ser rastreador em um aplicativo.
 * 
 * useEffect é um hook que permite executar efeitos colaterais em
 * seus componentes, por exemplo: buscar dados, atualizar diretamente
 * o DOM e cronômetros, ele aceita dois argumentos o segundo é opcional.
 * 
 * useCallback é um hook que retorna uma função de retorno
 * de chamada memorizada
 */
import { useState, useEffect, useCallback } from 'react';
import SliderColorPicker from 'views/MapView/components/SliderColorPicker';
/**
 *  useMap é um hook personalizado criado para gerenciar a comunicação
 *  dos componentes com o mapa.
 */
import { useMap } from 'views/MapView/hooks';
import * as Yup from 'yup';

/**
 * Ferramenta Merge
 * Uma funcionalidade usada em camadas criadas e importadas do tipo polígono
 * Com ela é possivel criar um poligo a partir da área de sobreposição comum
 * entre as feições de uma ou duas camadas selecionadas no menu de camadas.
 * Também é posśivel especificar as feições selecionando-as na tabela de atributos.
 * 
 * @param {string} mapContext Context
 * @param {boolean} isActive Verificação
 * @param {boolean} setIsActive Seta o estado
 * @param {*} props Resto
 * @returns 
 */
export const Merge = ({ mapContext, isActive, setIsActive, ...props }) => {  
  const [arrSelectedLayers, setArrSelectedLayers] = useState([])
  const [saveModalOpen, setSaveModalOpen] = useState(false);  
  const [runingMerge, setRuningMerge] = useState(false);
  const [collectionMerge, setCollectionMerge] = useState({});
  const [enabledTool, setEnabledTool] = useState(null)
  const [type, setType] = useState('')
  const { layers, map, addLayer, setLoadingInMap} = useMap();
  const formik = useFormik({
    initialValues: {
      layerName: '',
      layerStyle: null,
    },
    validationSchema: Yup.object().shape({
      layerName: Yup.string().required('Campo obrigatório'),
    }),
    onSubmit: (values) => {
      saveAsLayer(values.layerName, values.layerStyle);
    },
  });

  const { resetForm } = formik;  
  
  /**
   * Salva a operação realizada em uma nova camada, que será lista no menu
   * @param {*} layerName Nome que deverá aparecer no menu
   * @param {*} layerStyle Estilo de como a camada deverá ser representada no mapa   
   */
  const saveAsLayer = useCallback((layerName, layerStyle) => {
    if (collectionMerge) {
      const customRender = L.canvas({ pane: 'mixedPane' });
      let options = {
        pane: 'mixedPane',
        renderer: customRender,
        style: layerStyle,
        pointToLayer: function (feature, latlng) {
          return L.circleMarker(latlng, {
            pane: 'mixedPane',
            ...layerStyle,
            renderer: customRender,
          });
        },
      };

      const geoJsonLayer = L.geoJSON(collectionMerge, options);
      let layerToAdd = new Layer(
        null,
        'criada',
        null,
        layerName,
        null,
        null,
        null,
        null,
        null
      );      
      layerToAdd.setLeafletLayer(geoJsonLayer);      
      
      //Seta todas as camadas selecionadas(objetos) dentro de um array vazio
      let arrFeatures = []// feiçao modelo   
      layerToAdd.leafletLayer.eachLayer((feature) => {        
        arrFeatures.push(feature.feature.properties)    
      });      
      
      //Inicia desenvolvimento da camada modelo para tabela de atributos
      //Pega as keys de todas as feiçoes com duplicidade
      let arrNamesColumn = []
      for (let i = 0; i < arrFeatures.length; i++) {
        //for in usado para iterar dentro de cada objeto 
        //para pegar o nome das propriedades
        for (const nameColumn in arrFeatures[i]) {
          arrNamesColumn.push(nameColumn)          
          if(arrFeatures[i][nameColumn] === ''){
            arrFeatures[i][nameColumn] = '-'
          }
        }        
      }      

      //Cria uma feição modelo com todas as colunas da junção de todas as feiçoes 
      //retirando duplicidade para ser usada na tabela de atributos      
      let modelLayerTableAttribute = {}
      for (let i = 0; i < arrNamesColumn.length; i++) {
        let name = arrNamesColumn[i];
        modelLayerTableAttribute = {
          ID_GBA: '-',
          ...modelLayerTableAttribute,
          [name]: '-',
        }
      }            

      let countIdFeature = 1;   
      layerToAdd.leafletLayer.eachLayer((feature) => {      
        let newFeatureProperties = {};        
        newFeatureProperties = {
          ...modelLayerTableAttribute,
          ...feature.feature.properties,
          ID_GBA: countIdFeature,          
        }
        feature.feature.properties = newFeatureProperties;        
        countIdFeature++;                        
      });
          
      addLayer(layerToAdd);      
      setSaveModalOpen(false);
    }    
  }, [collectionMerge, addLayer]);
  

  /**
   * Reseta formik para estado inicial e fecha modal
   */
  const handleCloseSaveModal = useCallback(() => {
    resetForm();
    setSaveModalOpen(false);
  }, [resetForm]);
    
  /**
   * Inicia procedimento para execução de merge
   */
  const runMerge = useCallback(() => {         
    if (!runingMerge) {
      setRuningMerge(true);
      setLoadingInMap(true);
      setTimeout(function () {

        let arrayTurfedLayers = []
      
        //o metodo getTurfed transforma a layer recebida no modelo como o turf aceita, e joga ela dentro de um array [{...}]     
        arrSelectedLayers.forEach((item) => {
          let layerModelTurf = getTurfedFeatures(item, true)           
          if(layerModelTurf.length >= 2){
            for (const obj of layerModelTurf) {
              arrayTurfedLayers.push(obj)
            }
            return arrayTurfedLayers
          }

          return arrayTurfedLayers.push(layerModelTurf[0])
        })

        //pega o type do camada
        let typeLayer = arrSelectedLayers[0].dataType
        if(typeLayer === "LineString" || typeLayer === "Line"){
          typeLayer = "Polygon"
        }
        
        
        setCollectionMerge(turf.featureCollection(arrayTurfedLayers));
        setType(typeLayer)
        setSaveModalOpen(true); 
        setRuningMerge(false);   
        setLoadingInMap(false);
      }, 500);
    }      
  }, [runingMerge, arrSelectedLayers, setLoadingInMap]);  
  
  /** EFFECTS */

  useEffect(() => {
    setEnabledTool(false)
    let selectedLayers = layers.filter((l) => l.isSelected && l.visible);
    //verificar se tem duas ou mais camadas selected
    if((selectedLayers.length >= 2)){      
      //verificar se é importada ou criadas
      let layersImportedAndCreated = true
      selectedLayers.forEach((item, index) => {      
        if(!['importada', 'criada'].includes(selectedLayers[index].type)){
          layersImportedAndCreated = false        
        }
      })
  
      if(layersImportedAndCreated){
        let hasPolygon = false
        let hasLine = false
        let hasPoint = false           
        //verificar se todas as camadas sao do mesmo tipo
        selectedLayers?.forEach((item, index) => {                
          if(['Polygon', 'MultiPolygon'].includes(selectedLayers[index].dataType)){
            hasPolygon = true
          }else if(['Point', 'MultiPoint'].includes(selectedLayers[index].dataType)){
            hasPoint = true
          }else if(['LineString', 'MultiLineString'].includes(selectedLayers[index].dataType)){
            hasLine = true
          }                      
        })      
        //habilita ou desabilita a ferramenta de merge
        if(hasPolygon && !hasPoint && !hasLine){
          setEnabledTool(true)
        }else if(!hasPolygon && hasPoint && !hasLine){
          setEnabledTool(true)
        }else if(!hasPolygon && !hasPoint && hasLine){
          setEnabledTool(true)
        }else {
          setEnabledTool(false)
        }        
      }      
    }

    //Depois de todas as verificaçoes, seta as camadas em um state global
    setArrSelectedLayers(selectedLayers)    
  }, [layers])  

  /**
   * Reseta ferramenta ao ser desabilitada
   */
  useEffect(() => {
    if (!isActive) {      
      handleCloseSaveModal();
      setType('')      
    }
  }, [isActive, handleCloseSaveModal]);

  /**
   * Adiciona e executa um evento customizado. Ao final remove evento.
   */
  useEffect(() => {
    if (isActive && !runingMerge) {
      map.on('run-merge', runMerge);
      map.fire('run-merge'); 
      setIsActive(false);      
      map.off('run-merge');
    }
  }, [isActive, runingMerge, map, runMerge, setIsActive]);

  return (
    <Wrap>
      <ButtonTooltip
        tooltip={Merge.properties.alias}
        description={Merge.properties.description}
        onClick={() => {          
          setIsActive();          
        }}
        tooltipDisabled={isActive}
        active={isActive}
        disabled={!enabledTool}
      >        
        <Icon i="map-toolbar-merge"></Icon>
      </ButtonTooltip>   


        <CustomModalSaveAsLayer
        title="Salvar Camada"
        saveModalOpen={saveModalOpen}
        handleCloseSaveModal={handleCloseSaveModal}
        formik={formik}
        SliderColorPicker={ <SliderColorPicker
          geometryType={type}
          autoSelect={false}
          selectedSymbology={formik.values.layerStyle}
          onSelect={(style) => formik.setFieldValue('layerStyle', style)}
        />}
      />  


 
    </Wrap>
  );
};

Merge.properties = {
  id: 'CPN-TB-A-MERGE',
  alias: 'Mesclar',
  description: 'Realiza a combinação de camadas. Selecionando duas ou mais camadas criada(s) e/ou importada(s) com feiçoes do mesmo tipo, podendo especificar feições.',
};

export default Merge;
